/**
 * @fileoverview GET handler for "/decisioning_studio_agents/:app_group_id/:dsa_id/constraints/:component".
 * Returns the templated single-component constraint (decoded from Conman's
 * filter-based guardrail) or `{data: null}` when none is configured.
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent } from "./constants";
import type {
  ConstraintComponent,
  GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdConstraintsComponent,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string,
    component: ConstraintComponent
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult> =>
    fetch(`/decisioning_studio_agents/${appGroupId}/${dsaId}/constraints/${component}`, "GET", {}, { signal }),
  isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult
);
